export enum RouteStatus{
    PENDING = "PENDENTE", 
    STARTED = "INICIADA", 
    FINISHED = "TERMINADA",
    CANCELED = "CANCELADA"
}